import { useCallback } from "react";
import { downloadCSVFile, downloadXLSFile, exportSvgToPng, toggleFullscreen } from "../d3utility";

/**
 * Hook that provides StepChart export action handlers.
 * @param {React.RefObject} wrapperRef - Ref to the chart wrapper for fullscreen
 * @param {React.RefObject} svgContainerRef - Ref to the SVG container for PNG export
 * @param {React.RefObject} chartDataRef - Ref to the chart data for CSV/XLS export
 * @param {Function} closeMenu - Callback to close the context menu after action
 * @returns {{ handleFullscreen, handleDownloadCSV, handleDownloadXLS, handleDownloadPNG }}
 */
export default function useStepChartExport(wrapperRef, svgContainerRef, chartDataRef, closeMenu, siteTimezone) {
  const handleFullscreen = useCallback(() => {
    if (wrapperRef.current) {
      toggleFullscreen(wrapperRef.current);
    }
    closeMenu();
  }, [wrapperRef, closeMenu]);

  const handleDownloadCSV = useCallback(() => {
    if (!chartDataRef.current) return;
    downloadCSVFile(chartDataRef.current, undefined, siteTimezone);
    closeMenu();
  }, [chartDataRef, closeMenu, siteTimezone]);

  const handleDownloadXLS = useCallback(() => {
    if (!chartDataRef.current) return;
    downloadXLSFile(chartDataRef.current, undefined, siteTimezone);
    closeMenu();
  }, [chartDataRef, closeMenu, siteTimezone]);

  const handleDownloadPNG = useCallback(() => {
    const svgEl = svgContainerRef.current?.querySelector("svg");
    if (!svgEl) return;
    exportSvgToPng(svgEl);
    closeMenu();
  }, [svgContainerRef, closeMenu]);

  return { handleFullscreen, handleDownloadCSV, handleDownloadXLS, handleDownloadPNG };
}
